import {
  Card,
  Col,
  Icon,
  Link,
  ListGroup,
  ListGroupItem,
  Row,
  useApp
} from 'straightline-ui';
import { formatDate, formatDistanceToNow } from 'straightline-utils/time';

const icons = {
  eta: 'calendar',
  tracking: 'map-pin',
  status_change: 'activity'
};

const colors = {
  eta: 'primary',
  tracking: 'info',
  status_change: 'success'
};

export default function ShipmentEventsCard() {
  const app = useApp();

  const params = {
    query: {
      $limit: 5,
      $sort: { created_at: -1 }
    }
  };

  const options = { keepPreviousData: true, refetchInterval: 60000 };

  const {
    result: statusChanges,
    isLoading: statusChangesIsLoading,
    isError: statusChangesIsError
  } = app.service('api/shipment-status-changes').useFind(params, options);

  const {
    result: shipmentTracks,
    isLoading: shipmentTracksIsLoading,
    isError: shipmentTracksIsError
  } = app.service('api/shipment-tracking').useFind(params, options);

  const {
    result: shipmentEtas,
    isLoading: shipmentEtasIsLoading,
    isError: shipmentEtasIsError
  } = app.service('api/shipment-etas').useFind(params, options);

  const isLoading =
    statusChangesIsLoading || shipmentTracksIsLoading || shipmentEtasIsLoading;
  const isError =
    statusChangesIsError || shipmentTracksIsError || shipmentEtasIsError;

  if (isLoading || isError || !statusChanges?.total) {
    return <Loader />;
  }

  let events = [];

  statusChanges.data.forEach((statusChange) => {
    events.push({
      id: `status_change_${statusChange.id}`,
      type: 'status_change',
      data: statusChange
    });
  });

  shipmentTracks.data.forEach((track) => {
    events.push({
      id: `tracking_${track.id}`,
      type: 'tracking',
      data: track
    });
  });

  shipmentEtas.data.forEach((eta) => {
    events.push({
      id: `eta_${eta.id}`,
      type: 'eta',
      data: eta
    });
  });

  events = events
    .sort((a, b) => new Date(b.data.created_at) - new Date(a.data.created_at))
    .slice(0, 5);

  return (
    <Card className="card-fill">
      <div className="card-header">
        <div className="d-flex justify-content-between">
          <h3 className="card-header-title">Activity</h3>
        </div>
      </div>
      <ListGroup className="list-group-flush border-bottom">
        {events.map((event) => {
          const date = event.data.created_at;
          const shipment_id = event.data.shipment_id;
          const icon = icons[event.type];
          const color = colors[event.type];

          let text = '';

          switch (event.type) {
            case 'status_change':
              text = ` is now "${event.data.to_status.label}"`;
              break;
            case 'tracking':
              text = ` is in ${event.data.city}, ${event.data.state}`;
              break;
            case 'eta':
              text = ` is scheduled to ${
                event.data.type === 'pickup' ? 'pickup' : 'deliver'
              } on ${formatDate(event.data.date, 'dateTime')}`;
              break;
            default:
              break;
          }

          return (
            <ListGroupItem
              key={event.id}
              tag={Link}
              to={`/shipments/${shipment_id}`}
              className="list-group-item-action"
              style={{ paddingLeft: '1.25rem', paddingRight: '1.25rem' }}
            >
              <Row className="align-items-center">
                <Col xs="auto">
                  <div className="avatar avatar-sm">
                    <div
                      className={`avatar-title font-size-lg rounded-circle bg-${color} text-white`}
                    >
                      <Icon type={icon} />
                    </div>
                  </div>
                </Col>
                <Col className="ml-n2">
                  <div>
                    Shipment #{shipment_id} {text}
                  </div>
                  <small className="text-muted">
                    {formatDistanceToNow(date)}
                  </small>
                </Col>
              </Row>
            </ListGroupItem>
          );
        })}
      </ListGroup>
    </Card>
  );
}

const Loader = () => {
  const loaderLength = [1, 2, 3, 4, 5];
  return (
    <Card className="card-fill">
      <div className="card-header">
        <div className="d-flex justify-content-between">
          <h3 className="card-header-title">Activity</h3>
        </div>
      </div>
      <ListGroup className="list-group-flush">
        {loaderLength.map((item) => (
          <ListGroupItem
            key={item}
            style={{ paddingLeft: '1.25rem', paddingRight: '1.25rem' }}
          >
            <Row>
              <Col xs="auto">
                <div className="avatar avatar-sm">
                  <div className="avatar-title font-size-lg rounded-circle bg-light text-white">
                    {/* <Icon type="truck" /> */}
                  </div>
                </div>
              </Col>
              <Col className="ml-n2">
                <h5 className="mb-1">
                  <div
                    className="bg-light rounded"
                    style={{ height: 18, width: 200 }}
                  />
                </h5>

                <div
                  className="bg-light rounded"
                  style={{ height: 16, width: 60 }}
                />
              </Col>
            </Row>
          </ListGroupItem>
        ))}
      </ListGroup>
    </Card>
  );
};
